import { render, staticRenderFns } from "./payOnBehalf.vue?vue&type=template&id=89c2a9cc&scoped=true&"
import script from "./payOnBehalf.vue?vue&type=script&lang=js&"
export * from "./payOnBehalf.vue?vue&type=script&lang=js&"
import style0 from "./payOnBehalf.vue?vue&type=style&index=0&id=89c2a9cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c2a9cc",
  null
  
)

export default component.exports